(function () {
  function initGallery(gallery) {
    if (gallery.dataset.galleryInitialized === 'true') return;

    var track = gallery.querySelector('[data-gallery-track]');
    var previous = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (!track || !previous || !next) return;

    var originals = Array.prototype.slice.call(track.children);
    if (originals.length < 2) return;

    gallery.dataset.galleryInitialized = 'true';

    function cloneSlide(slide) {
      var clone = slide.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.dataset.galleryClone = 'true';
      return clone;
    }

    originals.slice().reverse().forEach(function (slide) {
      track.insertBefore(cloneSlide(slide), track.firstChild);
    });

    originals.forEach(function (slide) {
      track.appendChild(cloneSlide(slide));
    });

    var slides = Array.prototype.slice.call(track.children);
    var originalCount = originals.length;
    var index = originalCount + 1;
    var offsets = [];
    var isMoving = false;

    function getPeek() {
      return parseFloat(window.getComputedStyle(gallery).getPropertyValue('--gallery-peek')) || 0;
    }

    function setTransition(enabled) {
      track.style.transition = enabled ? '' : 'none';
    }

    function measure() {
      var offset = 0;
      offsets = slides.map(function (slide) {
        var current = offset;
        offset += slide.getBoundingClientRect().width;
        return current;
      });
      move(false);
    }

    function move(animate) {
      if (!offsets.length) return;
      setTransition(animate);
      track.style.transform = 'translate3d(' + Math.round(getPeek() - offsets[index]) + 'px, 0, 0)';
      if (!animate) {
        requestAnimationFrame(function () {
          setTransition(true);
        });
      }
    }

    function normalize() {
      if (index >= originalCount * 2) {
        index -= originalCount;
        move(false);
      } else if (index < originalCount) {
        index += originalCount;
        move(false);
      }
      isMoving = false;
    }

    function go(direction) {
      if (isMoving) return;
      isMoving = true;
      index += direction;
      move(true);
    }

    previous.addEventListener('click', function () {
      go(-1);
    });

    next.addEventListener('click', function () {
      go(1);
    });

    track.addEventListener('transitionend', function (event) {
      if (event.target === track) normalize();
    });

    gallery.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') go(-1);
      if (event.key === 'ArrowRight') go(1);
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(measure, 120);
    });

    var images = Array.prototype.slice.call(track.querySelectorAll('img'));
    Promise.all(images.map(function (image) {
      if (image.complete) return Promise.resolve();
      if (image.decode) return image.decode().catch(function () {});
      return new Promise(function (resolve) {
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', resolve, { once: true });
      });
    })).then(measure);

    measure();
  }

  function initAll(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('[data-gfw-b2b-gallery]')).forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
